export default {
  update: { method: "put", url: "guiche/update" },
};
